import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { orderRequest, orderRequestError, orderRequestSuccess } from '../../slices/Cart/OrderRequestSlice';

export const OrderRequestAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(orderRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.orderRequest,
                data: data,
            })
            return dispatch(orderRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(orderRequestError(_error));
        }
    };
};
